import { render } from "./WechatSendMessage.vue?vue&type=template&id=53191cee&scoped=true"
import script from "./WechatSendMessage.vue?vue&type=script&lang=js"
export * from "./WechatSendMessage.vue?vue&type=script&lang=js"

import "./WechatSendMessage.vue?vue&type=style&index=0&id=53191cee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53191cee"]])

export default __exports__